// extracted by mini-css-extract-plugin
module.exports = {"userlist":"menulist_userlist_1n58_"};